import { Component, OnInit, EventEmitter } from '@angular/core';
import { HttpService, SessionService, MessageService, TableColumns, TableConfiguration, params, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { Router, ActivatedRoute } from '@angular/router';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { UserServiceService } from 'app/services/user-service.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Plan } from 'app/models2/configuration/plan';
import { User } from 'app/models2/administration/user';
import { BaseResponse } from 'app/models2/commos/base-response';
import { DeleteGenericService } from 'app/services/delete-generic.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Usuarios",
    current:true
  }]

  public urlGetUsersTable: string = `${EndpointDictionary.User.USER_TABLE}`;
  private urlUsuarios: string = `${EndpointDictionary.User.CRUD_USER_DATA}`;
  private inactivateUser: string = `${EndpointDictionary.User.INACTIVATE_USER}`;
  private activeUser: string = `${EndpointDictionary.User.ACTIVE_USER}`;

  public params: params[] = [
    {
      id:'state',
      value: 1
    }]
    public params2: params[] = [
      {
        id:'state',
        value: 0
      }]

  public columnasUsuarios: TableColumns<User>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'text',
      style: {
        textAlign: 'center'
      },

    },
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    // {
    //   ID: 'jobTitle',
    //   label: 'Cargo',
    //   type: 'text',
    //   style: {
    //     textAlign: 'center',
    //     movil:'no-movil'
    //   },
    // },
    {
      ID: 'area',
      label: 'Área',
      type: 'text',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
    {
      ID: 'phone',
      label: 'Teléfono',
      type: 'number',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
    {
      ID: 'role',
      label: 'Rol',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
     {
      ID: 'email',
      label: 'Correo',
      type: 'text',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
  ]

  public isChecked: boolean = true
  public labelToggle:string = "Usuarios activos"


  public recargarTablaUsuarios = new EventEmitter<any>()
  public recargarTablaUsuariosInactives = new EventEmitter<any>()
  public configurationUsuarios: TableConfiguration = {
    edit: true,
    add: true,
    delete: false,
    selectable:true,
    addPer: true,
    editPer: true,
    primaryKey: 'userId',
    active:true
  }

  public configurationUsuariosInactives: TableConfiguration = {
    primaryKey: 'userId',
    active:true,
    selectable:true,
  }

  public dataUsuarios: Array<User>

  constructor(
    private http: HttpService,
    private router: Router,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
    private message: MessageService,
    public userService: UserServiceService,
    private storage : LocalStorageService,
    private deleteService: DeleteGenericService
  ) {
   }

  ngOnInit(): void {
  }

  public agregarUsuario($event:number){
    let plan: Plan = this.storage.get('plan')
    if($event < plan.numberUsers) {
      this.session.setData('redireccion', 'nuevo')
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute })
    }else{
      this.message.Warning("Limite del plan","Adquiera un nuevo plan")
    }
  }

  public editarUsuario($event:Array<User>){
    this.editUser($event[0])
  }

 async inactivateOrActiveUser($event: User[], active:boolean) {
   if (!Array.isArray($event)) {
    $event = [$event];
  }
   await this.deleteService.inactivateOrActivate($event, active, this.activeUser, this.inactivateUser, 'Usuario')
   if(active){
    this.recargarTablaUsuariosInactives.emit()
  }else{
    this.recargarTablaUsuarios.emit()
  }
}

  seleccionadosUsuarios($event) {
    ////console.log($event)
  }

  public clickFilaUsuarios($event:User) {

  }

  private editUser(user:User){

    this.http.getData(`${this.urlUsuarios}/${user.userId}`).subscribe(
      (res: BaseResponse<Array<User>>) => {

        if (res['code'] === 0) {
          this.session.setData('usuarioData', res['body'][0])
          this.session.setData('redireccion', 'actualizar')
          this.router.navigate(['detalle'], { relativeTo: this.activeRoute })
        } else {
          this.message.Error('Error!', `Código:${res['code']} - Mensaje: ${res['message']}`)
        }
      },
      err=>{
        this.message.Error('Error!',err['message'])
      }
    )
  }

  clickRowUserInactive($event){
  }

  changeToggle($event:MatSlideToggleChange){
    if($event.checked){
      this.labelToggle = "Usuarios Activos"
    }else{
      this.labelToggle = "Usuarios Inactivos"
     }
  }


}

